/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: TestimonialPage
 * Page name: Testimonial page
 * Page Description: This is the Testimonial page of the website of Ekathva Innovations.
 */

import React, { useEffect } from "react";
import MetaTags from "react-meta-tags";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-multi-carousel/lib/styles.css";
import Footer from "components/Footers/Footer";

import "assets/style/Style.css";
import TestimonialData from "./TestimonialData";
import data from "../api/json/testimonial.json";

function TestimonialsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <MetaTags>
        <title>
          Testimonials - What our clients say about our work| Ekathva
          Innovations Pvt Ltd{" "}
        </title>
      </MetaTags>

      <TestimonialData data={data} />
      <Footer />
    </div>
  );
}

export default TestimonialsPage;
